<script>
export default {
    name: "StatementDashboard",

    data() {

        return {
            active: 2,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    methods: {

    },

    components: {
        "organ-receipt-tab": () => import('./tabs/Organ_Receipts.vue'),
        "organ-statement-tab": () => import('./tabs/Organ_Statement.vue'),
       
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-medium text-sm">Organization Payment Report</h5>
        </template>
        <template v-slot:card-body>
            <div class="w-full flex flex-wrap">
                <ul class="w-full flex border-b mb-2">
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 2" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 2 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Payment Report</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 3" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 3 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Statement</a>
                  </li>
                  
                </ul>
                <organ-receipt-tab v-if="active === 2" />
                <organ-statement-tab v-if="active === 3" />
               
            </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
